<template>
<v-container fluid>
  <v-layout justify-center>
    <v-flex md8>
      <DataTableMainLocal :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
    </v-flex>
  </v-layout>
  <MainFormDialog v-if="get_dialogMain.dialog" :model="object" :params="paramsMain" />
</v-container>
</template>

<script>
// import router from '@/router'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import DataTableMainLocal from '@/components/tables/DataTableMainLocal'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'inventario.marcas.create' }
        ],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Empresa', value: 'empresa.nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Agregar Modelo', icon: 'mdi-pencil', color: 'blue darken-1', action: 'toCreateModelMarca', code: 'inventario.marcas-modelo.create' }
        ]
      },
      footer: {
        paging: true
      }
    },
    paramsMain: {},
    form: [],
    object: {},
    url: {},
    message: '',
    user: {}
  }),
  mounted () {
    this.user = this.$cookies.get('user')
    this.getDataUrl('inventario.marcas.list')
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  components: {
    DataTableMainLocal,
    MainFormDialog
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    successAction (item) {
      this[item.action](item)
    },
    newData (item) {
      this.object = { empresa_id: this.user.empresa_id }
      this.paramsMain = {
        form: this.get_MarcaForm,
        url: this.get_urls['inventario.marcas.create'],
        message: 'Registro Agregado Correctamente'
      }
      this.SHOW_DIALOG_MAIN({ type: 'form', with: 500, title: 'Nueva Marca' })
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('inventario.marcas.list')
    },
    tableAction (item) {
      // acciones de cada row
      this[item.action](item)
    },
    toCreateModelMarca ({ item }) {
      this.object = { empresa_id: this.user.empresa_id, padre_id: item.id }
      this.paramsMain = {
        form: this.get_MarcaForm,
        url: this.get_urls['inventario.marcas-modelo.create'],
        message: 'Registro Agregado Correctamente'
      }
      this.SHOW_DIALOG_MAIN({ type: 'form', with: 500, title: `Agregar Modelo (${item.nombre})` })
    },
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects',
      'get_MarcaForm'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('inventario.marcas.list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
